import React from 'react'
import {benefitCard} from '../styles/benefitCard.module.css'

export default function BenefitsCard({ benefit}) {
    return (
        <div className={benefitCard}>
            {benefit}
        </div>
    )
}
